import React from 'react'
import clsx from 'clsx'

import {  SpanProps } from './SpanProps'

import './SpanStyles.scss'
import { APP_COLOR, APP_FONT_SIZE } from '../AtomsGlobalProps'


/**
 * Atom pozwalający na tworzenie spanów zgodnych z systemem designu.
 * 
 * @param {APP_COLOR} color - Kolor paragrafu zgodny z systemem designu.
 * @param {APP_FONT_SIZE} size  - Rozmiar paragrafu zgodny z systemem designu.
 * @param {String} html  - Dodatkowy HTML, który zostanie użyty w atrybucie dangerouslySetInnerHTML zamiast być użytym jako children w komponencie
 * @param {Boolean} bold - Czy pogrubiony
 * @param {Boolean} italic - Czy kursywą
 * @param {String} className - Dodatkowa klasa pozwalająca dodać customowe właściwości
 * @returns 
*/
const Span = (props: SpanProps) => {
   const { color = APP_COLOR.PRIMARY, size = APP_FONT_SIZE.MEDIUM, html, bold, italic, className, children, ...rest } = props
   const classes = clsx(className, 'app-span', `app-span--${color.toLowerCase()}`, `app-span--${size.toLowerCase()}`)
   const styles = { fontWeight: bold ? 600 : 400, fontStyle: italic ? "italic" : "normal" }


   // Gdy przekazujemy propsa html - nie może on mieć dzieci, stąd musimy obsłużyć to inaczej
   if(html) {
      return (
         <span className={classes} style={styles} dangerouslySetInnerHTML={{ __html: props.html }} {...rest} />
      )
   }

   return (
      <span className={classes} style={styles} {...rest}>
         { children} 
      </span>
   )
}

export default Span